import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import _ from 'lodash';
import SimpleChart from '../SimpleChart.js';
import 'luxon';
import 'styled-components';
import '../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import '../../../theme/ThemedComponentWrapper.js';
import '../../icons/ActivityIcon.js';
import '../../icons/ArrowDownIcon.js';
import '../../icons/ArrowDownRightCircleIcon.js';
import '../../icons/ArrowLeftAlignIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightAlignIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/ArrowSwitchIcon.js';
import '../../icons/ArrowUpIcon.js';
import '../../icons/ArrowUpRightCircleIcon.js';
import '../../icons/ArrowsAngleExpandIcon.js';
import '../../icons/BankIcon.js';
import '../../icons/CheckIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CopyIcon.js';
import '../../icons/CrossIcon.js';
import '../../icons/DaiIcon.js';
import '../../icons/DangerIcon.js';
import '../../icons/DownSortIcon.js';
import '../../icons/ExclamationTriangleIcon.js';
import '../../icons/ExpandKpiIcon.js';
import '../../icons/EyeIcon.js';
import '../../icons/EyeSlashIcon.js';
import '../../icons/Grid1x2Icon.js';
import '../../icons/InfoCircleIcon.js';
import '../../icons/ListIcon.js';
import '../../icons/LockIcon.js';
import '../../icons/MediumIcon.js';
import '../../icons/MoonIcon.js';
import '../../icons/PiggyBankIcon.js';
import '../../icons/QuestionMarkCircleIcon.js';
import '../../icons/ShieldIcon.js';
import '../../icons/SunIcon.js';
import '../../icons/UpSortIcon.js';
import '../../icons/XIcon.js';
import '../../atoms/Input/Input.js';
import '../../atoms/ToggleSwitch.js';
import '../../atoms/Table/Table.js';
import '../../atoms/Table/components/HeaderCell/HeaderCell.js';
import '@floating-ui/react';
import '../../atoms/Tooltip/components/TooltipContext.js';
import '../../atoms/Tooltip/components/TooltipContent.js';
import '../../atoms/Tooltip/components/TooltipTrigger.js';
import '../../atoms/Table/components/Pagination/Pagination.js';
import '../../atoms/layout/Stack/Stack.js';
import 'ethereum-blockies-base64';
import '../../molecules/CurrencyValue/components/Value.js';
import '../../pictograms/EthPictogram.js';
import '../../pictograms/EtherScanPictogram.js';
import '../../pictograms/DebankPictogram.js';
import '../../pictograms/ZapperPictogram.js';
import '../../pictograms/DaiPictogram.js';
import '../../molecules/TrendValue.js';
import '../../molecules/KpiCard/KpiCard.js';
import '../../molecules/Tabs/Tabs.js';
import EmptyBox from '../../molecules/EmptyBox.js';
import '../ChartKpis/ChartKpi.js';
import '../ChartJS.js';
import '../Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../XRay.js';

function BarChart({ data, datasets, config, ...rest }) {
    const mergedConfig = useMemo(() => {
        const defaultConfig = {
            type: 'bar',
            options: {
                scales: {
                    x: {
                        stacked: true
                    },
                    y: {
                        beginAtZero: true,
                        stacked: true
                    }
                },
                elements: {
                    bar: {
                        hoverBorderWidth: 0
                    }
                }
            }
        };
        return _.merge(defaultConfig, config);
    }, [config]);
    if (datasets) {
        return (jsx(SimpleChart, { data: data, datasets: datasets, config: mergedConfig, ...rest }));
    }
    return jsx(EmptyBox, {});
}

export { BarChart as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
